import { searchActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    searchStr: '',
    loading: false,
    resultCountRequested: 0,
    resultCountReturned: 0,
    page: 1
};

export const reducer = createReducer(initialState, {
    [searchActions.searchTyped]: (state, action) => {
        state.searchStr = action.payload;
    },
    [searchActions.searchRequest]: (state, action) => {
        state.loading = true;
    },
    [searchActions.searchSuccess]: (state, action) => {
        state.loading = false;
        state.page = action.payload.result.page;
        state.resultCountRequested = action.payload.result.resultCountRequested;
        state.resultCountReturned = action.payload.result.resultCountReturned;
        state.totalResults = action.payload.result.totalResults;
    },
    [searchActions.searchClear]: (state, action) => {
        state.loading = false;
        state.searchStr = '';
    }
})


